import { Link, graphql, useStaticQuery } from "gatsby"

import { Container } from "react-bootstrap"
import { FlagsWrapper } from "./Flags.styles"
import Img from "gatsby-image"
import React from "react"
import ReactTooltip from "react-tooltip"

const Flags = () => {
  const data = useStaticQuery(graphql`
    {
      allFile(filter: {relativeDirectory: {eq: "country_report/country_flags"}}) {
        edges {
          node {
            id
            name
            childImageSharp {
              fixed(width: 50, height: 50, cropFocus: CENTER) {
                ...GatsbyImageSharpFixed
              }
            }
          }
        }
      }
      statamic {
        entries(collection: "country_reports", sort: "country_name asc", limit: 500) {
          data {
            id
            slug
            ... on Statamic_Entry_CountryReports_CountryReport {
              country_name
              country_flag
            }
          }
        }
      }
    }
  `)
  const countryReports =
    (data && data.statamic && data.statamic.entries && data.statamic.entries.data) || []
  const images = (data.allFile && data.allFile.edges) || []

  return (
    <FlagsWrapper className="secondary-blue-3-background">
      <Container className="py-5 px-3 px-lg-0 ">
        <div className="grid">
          {countryReports.map((report) => {
            if (!report || !report.slug) return null

            const flagName = Array.isArray(report.country_flag)
              ? report.country_flag[0]
              : report.country_flag
            if (!flagName) return null

            const match = images.find((image) => image.node.name === flagName)
            const fixed = match && match.node.childImageSharp && match.node.childImageSharp.fixed
            if (!fixed) return null

            const countryName = report.country_name

            return (
              <Link
                key={report.id}
                className="flag-container"
                to={`/country-report/${report.slug}/`}
                target="_blank"
              >
                <div className="d-flex flex-column align-items-center">
                  <Img
                    fixed={fixed}
                    className="flag-img rounded-circle mb-3"
                    alt={`${countryName} flag`}
                  />
                  <ReactTooltip class="tt" place="bottom">
                    <span>{countryName}</span>
                  </ReactTooltip>
                  <p className="text-center d-block text-white">{countryName}</p>
                </div>
              </Link>
            )
          })}
        </div>
      </Container>
    </FlagsWrapper>
  )
}

export default Flags
